/** XeAgents.ai**/
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { LANGUAGE_STORAGE_KEY, regionLanguage } from '../lib/base-path';

import en from './locales/en.json';
import ar from './locales/ar.json';
import de from './locales/de.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import hi from './locales/hi.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import pl from './locales/pl.json';
import pt from './locales/pt.json';
import sv from './locales/sv.json';

import landingEn from './landing/en.json';
import landingAr from './landing/ar.json';
import landingDe from './landing/de.json';
import landingEs from './landing/es.json';
import landingFr from './landing/fr.json';
import landingHi from './landing/hi.json';
import landingIt from './landing/it.json';
import landingJa from './landing/ja.json';
import landingPl from './landing/pl.json';
import landingPt from './landing/pt.json';
import landingSv from './landing/sv.json';

export const languages = [
  { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸', direction: 'ltr' as const },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', direction: 'rtl' as const },
  { code: 'de', name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', direction: 'ltr' as const },
  { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', direction: 'ltr' as const },
  { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷', direction: 'ltr' as const },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳', direction: 'ltr' as const },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', direction: 'ltr' as const },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', direction: 'ltr' as const },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', flag: '🇵🇱', direction: 'ltr' as const },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷', direction: 'ltr' as const },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪', direction: 'ltr' as const },
];

export const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

const resources = {
  en: { translation: en, landing: landingEn },
  ar: { translation: ar, landing: landingAr },
  de: { translation: de, landing: landingDe },
  es: { translation: es, landing: landingEs },
  fr: { translation: fr, landing: landingFr },
  hi: { translation: hi, landing: landingHi },
  it: { translation: it, landing: landingIt },
  ja: { translation: ja, landing: landingJa },
  pl: { translation: pl, landing: landingPl },
  pt: { translation: pt, landing: landingPt },
  sv: { translation: sv, landing: landingSv },
};

// Under a country prefix (/germany) the page opens in that country's language unless the visitor chose another
const detector = new LanguageDetector();
detector.addDetector({ name: 'regionPath', lookup: () => regionLanguage(), cacheUserLanguage: () => undefined });

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: languages.map((l) => l.code),
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'regionPath', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      // 'de-DE' -> 'de', so the selector and the RTL check see a supported code.
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
  });

export default i18n;
